import { format } from 'date-fns';
import type { TimeBlock } from '../types';

interface EditModalProps {
  block: TimeBlock;
  onClose: () => void;
  onTitleChange: (block: TimeBlock, title: string) => void;
  onTimeChange: (field: 'startTime' | 'endTime', value: string) => void;
  onDeleteClick: () => void;
}

export const EditModal = ({
  block,
  onClose,
  onTitleChange,
  onTimeChange,
  onDeleteClick,
}: EditModalProps) => (
  <div>
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-semibold">Edit Time Block</h2>
      <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>

    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Title
        </label>
        <input
          type="text"
          value={block.title}
          onChange={(e) => onTitleChange(block, e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Start Time
          </label>
          <input
            type="time"
            value={format(block.startTime, 'HH:mm')}
            onChange={(e) => onTimeChange('startTime', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            End Time
          </label>
          <input
            type="time"
            value={format(block.endTime, 'HH:mm')}
            onChange={(e) => onTimeChange('endTime', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      <div className="flex justify-between pt-4">
        <button
          onClick={onDeleteClick}
          className="px-4 py-2 text-red-600 hover:text-red-700 font-medium"
        >
          Delete
        </button>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
);
